export const MANAGED_SERVICES = [
    'api-server',
    'frontend',
    'postgres',
    'sync-agent',
    'hl7-middleware',
    'filestore',
];
//# sourceMappingURL=container-services.js.map